import { Divider, IconButton, Menu } from '@material-ui/core'
import { MoreVertOutlined } from '@material-ui/icons'
import { BoMItemType } from 'model/Project/BoMItemRow'
import { useRef, useState } from 'react'
import { CheckManufacturabilityMenuItem } from '../BoMItemMenu/MenuItems/CheckManufacturabilityMenuItem'
import { CopyMaterialMenuItem } from '../BoMItemMenu/MenuItems/CopyMaterialMenuItem'
import { DeleteMenuItem } from '../BoMItemMenu/MenuItems/DeleteMenuItem'
import { DownloadBomItemFilesMenuItem } from '../BoMItemMenu/MenuItems/DownloadBomItemFilesMenuItem'
import { EventLogMenuItem } from '../BoMItemMenu/MenuItems/EventLogMenuItem'
import { OpenDetailsSidePanelButton } from '../BoMItemMenu/MenuItems/OpenDetailsSidePanelButton'
import { OpenOnErpMenuItem } from '../BoMItemMenu/MenuItems/OpenOnErpMenuItem'
import { PasteMaterialMenuItem } from '../BoMItemMenu/MenuItems/PasteMaterialMenuItem'
import { PurchasingPartMenuItem } from '../BoMItemMenu/MenuItems/PurchasingPartMenuItem'
import { RegressionTestMenuItem } from '../BoMItemMenu/MenuItems/RegressionTestMenuItem'
import { RememberOrForgetGeometryAsPurchasingMenuItem } from '../BoMItemMenu/MenuItems/RememberOrForgetPurchasingMenuItem'
import { ReportRecognitionIssuesMenuItem } from '../BoMItemMenu/MenuItems/ReportRecognitionIssuesMenuItem'

type Props = {
  bomItemId: string
}

export const PartTypeMenuButton = ({ bomItemId }: Props) => {
  const [open, setOpen] = useState(false)
  const buttonRef = useRef(undefined)

  const handleClose = () => setTimeout(() => setOpen(false))

  return (
    <>
      <IconButton
        onClick={() => setOpen(true)}
        ref={buttonRef}
        size="small"
        color="inherit"
      >
        <MoreVertOutlined />
      </IconButton>
      <Menu
        open={open}
        onClose={() => setOpen(false)}
        anchorEl={buttonRef.current}
      >
        <span>
          <OpenDetailsSidePanelButton
            bomItemType={BoMItemType.row}
            bomItemId={bomItemId}
            onClose={handleClose}
          />
          <OpenOnErpMenuItem bomItemId={bomItemId} onClose={handleClose} />
          <PurchasingPartMenuItem
            variant="modal"
            bomItemId={bomItemId}
            onClose={handleClose}
          />
          <PasteMaterialMenuItem bomItemId={bomItemId} onClose={handleClose} />
          <CopyMaterialMenuItem bomItemId={bomItemId} onClose={handleClose} />
          <Divider />
          <RememberOrForgetGeometryAsPurchasingMenuItem
            bomItemId={bomItemId}
            onClose={handleClose}
          />
          <CheckManufacturabilityMenuItem
            bomItemId={bomItemId}
            onClose={handleClose}
          />
          <DownloadBomItemFilesMenuItem
            bomItemId={bomItemId}
            bomItemType={'row'}
            onClose={handleClose}
          />
          <Divider />
          <DeleteMenuItem bomItemId={bomItemId} onClose={handleClose} />
          <Divider />
          <ReportRecognitionIssuesMenuItem
            bomItemId={bomItemId}
            onClose={handleClose}
          />
          <RegressionTestMenuItem bomItemId={bomItemId} onClose={handleClose} />
          <EventLogMenuItem
            bomItemId={bomItemId}
            bomItemType={BoMItemType.row}
            onClose={handleClose}
          />
        </span>
      </Menu>
    </>
  )
}
